module.exports = __webpack_public_path__ + "static/media/staff.4601385b.svg";